import React from 'react';
import emblem from '../../assets/brand/logo.svg';
import wordmark from '../../assets/brand/wordmark.svg';
import './brandLockup.scss';

export default function BrandLockup() {
  return <span className="avatus-lockup"><img className="avatus-lockup-emblem" src={emblem} alt="" /><span className="avatus-lockup-wordmark"><img src={wordmark} alt="AVATUS" /></span></span>;
}
